/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Icon } from './Icon';
import { IconFromJSON, IconFromJSONTyped, IconToJSON } from './Icon';
import type { ResourceType } from './ResourceType';
import {
	ResourceTypeFromJSON,
	ResourceTypeFromJSONTyped,
	ResourceTypeToJSON,
} from './ResourceType';

/**
 * A payload to create a new metadata schema for a client organization, client contact or service contact.
 * @export
 * @interface CreateMetadataSchema
 */
export interface CreateMetadataSchema {
	/**
	 * The name of the metadata schema
	 * @type {string}
	 * @memberof CreateMetadataSchema
	 */
	name: string;
	/**
	 *
	 * @type {ResourceType}
	 * @memberof CreateMetadataSchema
	 */
	resourceType: ResourceType;
	/**
	 *
	 * @type {Icon}
	 * @memberof CreateMetadataSchema
	 */
	icon?: Icon;
	/**
	 * JSON Schema definition
	 * @type {object}
	 * @memberof CreateMetadataSchema
	 */
	jsonSchema: object;
	/**
	 * A template string where placeholders will be replaced by metadata or primary contact property values
	 * @type {string}
	 * @memberof CreateMetadataSchema
	 */
	nameTemplate?: string;
}

/**
 * Check if a given object implements the CreateMetadataSchema interface.
 */
export function instanceOfCreateMetadataSchema(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'name' in value;
	isInstance = isInstance && 'resourceType' in value;
	isInstance = isInstance && 'jsonSchema' in value;

	return isInstance;
}

export function CreateMetadataSchemaFromJSON(json: any): CreateMetadataSchema {
	return CreateMetadataSchemaFromJSONTyped(json, false);
}

export function CreateMetadataSchemaFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CreateMetadataSchema {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		name: json['name'],
		resourceType: ResourceTypeFromJSON(json['resourceType']),
		icon: !exists(json, 'icon') ? undefined : IconFromJSON(json['icon']),
		jsonSchema: json['jsonSchema'],
		nameTemplate: !exists(json, 'nameTemplate') ? undefined : json['nameTemplate'],
	};
}

export function CreateMetadataSchemaToJSON(value?: CreateMetadataSchema | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		name: value.name,
		resourceType: ResourceTypeToJSON(value.resourceType),
		icon: IconToJSON(value.icon),
		jsonSchema: value.jsonSchema,
		nameTemplate: value.nameTemplate,
	};
}
